import React, { Component } from "react";
import { Link } from 'react-router-dom'
import { shareFacebook, shareTwitter, shareWhatsapp, openNegishut } from "../Services/Sharing"

import "./Header.scss"

class Header extends Component {
  constructor() {
    super()
    this.state = {
      isSlided: false
    }
  }

  setScroll() {
    if (typeof (Storage) !== "undefined") {
      window.sessionStorage.setItem("scrollY", 0);
    }
  }
  componentWillMount() {
    window.addEventListener("scroll", () => {
      this.setState({
        isSlided: (window.scrollY > 0.15 * window.screen.height)
      })
    });
  }
  render() {
    return (
      <header>
        <div id="header" className={`${(this.state.isSlided ? "slided" : "")} ${(this.props.isArticle ? " article " : "")}`}>
          <div className="padding">
            <div className="container">
              <div className="publisher">
                <div className="logo"></div>
              </div>
              <Link to="/" className="projectlogo" onClick={this.setScroll}></Link>
              <div className="backtohomepage">
                <Link to="/">
                  <div className="text">
                    חזרה לעמוד הראשי
                </div>
                  <div className="arrow"></div>
                </Link>
              </div>
              <div className="utils">
                <div className={`share${(this.state.isShareActive ? " active " : "")}`}>
                  <div onClick={() => { openNegishut() }} className="negishut"></div>
                  <div onClick={() => { shareFacebook() }} className="facebook"></div>
                  <div onClick={() => { shareTwitter() }} className="twitter"></div>
                  <div onClick={() => { shareWhatsapp() }} className="whatsapp"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="virtualHeader" className={`${(window.location.href.indexOf("whoami") > -1 ? "lead" : "")}`}></div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header/Header.js